module.exports = __webpack_public_path__ + "static/media/awoolplanet_htu05.2907301c.gif";